import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { label: '首页', to: '/' },
  { label: '瓜田总览', to: '/dramas' },
  { label: '关于我们', to: '/about' },
  { label: '常见问题', to: '/faq' },
];

export default function SiteHeader() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const linkBase = 'whitespace-nowrap text-sm transition-colors duration-200';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        transparent
          ? 'bg-transparent py-4'
          : 'bg-background-50/95 py-3 backdrop-blur border-b border-background-200/70'
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2.5" aria-label="西瓜黑料 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
            瓜
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-wide transition-colors duration-300 ${
              transparent ? 'text-background-50' : 'text-foreground-950'
            }`}
          >
            西瓜黑料
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `${linkBase} ${
                  transparent
                    ? isActive
                      ? 'font-medium text-background-50'
                      : 'text-background-100/80 hover:text-background-50'
                    : isActive
                      ? 'font-medium text-primary-600'
                      : 'text-foreground-600 hover:text-primary-600'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/dramas"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors duration-200 md:inline-flex ${
              transparent
                ? 'bg-background-50 text-primary-700 hover:bg-background-100'
                : 'bg-primary-500 text-background-50 hover:bg-primary-600'
            }`}
          >
            开始追瓜
          </Link>

          <button
            type="button"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-9 w-9 items-center justify-center rounded-md md:hidden ${
              transparent ? 'text-background-50' : 'text-foreground-900'
            }`}
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="mt-3 border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `block rounded-md px-3 py-3 text-sm ${
                  isActive ? 'bg-primary-50 font-medium text-primary-700' : 'text-foreground-700'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
}